import { J } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReleaseNoteModel, VersionModel } from '@app/models/release-note-model';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { UtilityService } from '@app/services/utility/utility-service.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-release-note',
  templateUrl: './release-note.component.html',
  styleUrls: ['./release-note.component.scss'],
  standalone: false
})
export class ReleaseNoteComponent implements OnInit {
  releaseNote: ReleaseNoteModel | null = null; 
  releaseNoteVersions: VersionModel[] = [];
  applicationName: string = "";

  constructor(private _router: Router,
    private _utilityService: UtilityService,
    private _navigationService: NavigationService,
    private _activatedRoute: ActivatedRoute) {
      this._navigationService.onChange(false, false);
  };
  
  async ngOnInit(): Promise<void> {
    this.applicationName = this._activatedRoute.snapshot.paramMap.get('appName') ?? environment.releaseNoteApplication;
    this._utilityService.getReleaseNote(this.applicationName).subscribe({
      next: (data) => {
        if(data) {
          this.releaseNote = data;
          if (this.releaseNote.IsSuccessful) {
            this.releaseNoteVersions = this.releaseNote.Data.flatMap(note => note.Version);
          }
        }
      }
    });
  }

  closeReleaseNote(){
    this._router.navigate(['signin']);
  }

  getNoteTypeIcon(noteType: string): string {
    switch (noteType) {
      case 'New Feature':
        return 'star';
      case 'Fixed':
        return 'bug_report';
      case 'Upcoming Feature':
        return 'schedule';
      default:
        return 'create';
    }
  }

}
